export const documentProps = {
  title: 'Free IT & Operations Assessments',
  description:
    'Get a free Network Security Evaluation, Dark Web Scan, or Technology Bill Analysis from TenK Solutions. No sales pitch — just your results in 24 hours.',
};
